var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable } from 'rxjs';
import { releaseStream, tryDisplayMedia, tryMedia } from './devices.utils';
function setupSubscription(subscriber, streamCreator, constraints) {
    return __awaiter(this, void 0, void 0, function () {
        var isUnsubscribed, stream, unsubscribe, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isUnsubscribed = false;
                    unsubscribe = function () {
                        isUnsubscribed = true;
                        if (stream) {
                            releaseStream(stream);
                        }
                    };
                    subscriber.add(unsubscribe);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, streamCreator(constraints)
                        // If we unsubscribed before the stream was given to us, make sure it's released properly since we won't be using it anymore
                    ];
                case 2:
                    stream = _a.sent();
                    // If we unsubscribed before the stream was given to us, make sure it's released properly since we won't be using it anymore
                    if (isUnsubscribed) {
                        releaseStream(stream);
                    }
                    else {
                        // Don't complete the stream here. This means that the user has to manually (or as part of an operator chain) unsubscribe,
                        // and this will clean up the stream automatically.
                        subscriber.next(stream);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    subscriber.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function observableStreamGenerator(streamCreator) {
    return function (constraints) {
        return new Observable(function (subscriber) {
            setupSubscription(subscriber, streamCreator, constraints);
        });
    };
}
/**
 * Creates a media stream with the given constraints.
 * The media stream is released when the observable is unsubscribed.
 */
export var tryMedia$ = observableStreamGenerator(tryMedia);
/**
 * Creates a screenshare stream with the given constraints.
 * The media stream is released when the observable is unsubscribed.
 */
export var tryDisplayMedia$ = observableStreamGenerator(tryDisplayMedia);
//# sourceMappingURL=managed-try-media.js.map